import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

toast.configure();
export const Filters = memo((props) => {
  const { model_id, modelName, filters, using_filter_ids } = props;
  // 初期設定
  const [usingFilterIds, setUsingFilterIds] = useState([]);
  useEffect(() => {
    setUsingFilterIds(using_filter_ids);
  }, [])

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeFilter = (event) => {
    const { value } = event.target;
    setUsingFilterIds(value);
  };

  const displayNames = (selected) => {
    var dispName = [];
    selected.map(selected_value => {
      filters.map((filter) => {
        if (filter.id === selected_value) {
          dispName.push(filter.name);
        }
      })
    })
    return dispName.join(', ');
  }

  const onClickFiltersSubmit = () => {
    var data = { filter: { filter_ids: usingFilterIds }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/${modelName}/${model_id}/filterings`, data)
    .then(resp => {
      console.log(resp.data);
      setUsingFilterIds(resp.data);
      notify("success", "Filter Attribute successfully created!");
    })
    .catch(e => {
      console.log(e.response);
      setUsingFilterIds(using_filter_ids);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Filter create Error!");
    })
  }

  return (
    <>
      <FormControl sx={{ mr: 1, width: 250 }} size="small">
        <InputLabel id="multiple-checkbox-label">条件</InputLabel>
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={usingFilterIds}
          onChange={onChangeFilter}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => displayNames(selected)}
        >
          {filters.map((filter) => (
            <MenuItem key={filter.id} value={filter.id}>
              <Checkbox checked={usingFilterIds.indexOf(filter.id) > -1} />
              <ListItemText primary={filter.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <button onClick={onClickFiltersSubmit} className='btn btn-info text-white' title="フィルター設定実行">
        <i className='fas fa-filter' />
      </button>
    </>
  );
});
